module.exports = __webpack_public_path__ + "fonts/trust_sans_black-webfont.2dd9b30b.woff";